import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import ExperienceAcceleratorNotebook from './ExperienceAcceleratorNotebook';
import EADashboard from './EADashboard';
import QuizConverter from './QuizConverter';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/experience-accelerator-notebook" element={<ExperienceAcceleratorNotebook />} />
        <Route path="/ea_dashboard" element={<EADashboard />} />
        <Route path="/quiz-converter" element={<QuizConverter />} />
      </Routes>
    </Router>
  );
}

export default App;
